import axios from 'axios';

import {ab2str} from "../../../utils/utils";

export default {
  startRegister: ({ commit }, {cb, ...rest}) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    const url = `/engine/fido/register/start`;
    axios({
      url: url,
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(rest)
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        commit('fido/SET_START_REGISTER_RESPONSE', response.data, {root: true});
        if (typeof cb === 'function') {
          cb(null, response.data);
        }
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        if (typeof cb === 'function') {
          cb(err);
        }
        /* eslint-disable */
        console.log(err);
      });
  },
  registerPublicKey: ({ commit }, credential, cb = null) => {
    /* eslint-disable-next-line */
    console.log(credential);
    /* eslint-disable-next-line */
    console.log(credential.response.clientDataJSON);
    commit('ui/SHOW_OVERLAY', true, { root: true });
    const url = `/engine/fido/register/public-key`;
    const payload = {
      id: credential.id,
      rawId: ab2str(credential.rawId),
      clientData: ab2str(credential.response.clientDataJSON),
      // attestationObject: ab2str(credential.response.attestationObject)
    };
    axios({
      url: url,
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(payload)
    })
      .then((response) => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        if (typeof cb === 'function') {
          cb(null, response.data);
        }
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        if (typeof cb === 'function') {
          cb(err);
        }
        /* eslint-disable */
        console.log(err);
      });
  }
};
